export enum SortDirection {
    None = 'none',
    Ascending = 'asc',
    Descending = 'desc'
}

export type SortPayload = {
    [key: string]: SortDirection
};
